export default "__VITE_ASSET__RUIAvBFR__"